import { Navigate, useParams } from 'react-router-dom';

import ExpenseFormWrapper from '@/components/expenses/ExpenseFormWrapper';

export default function EditExpensePage() {
  const { id, expenseId } = useParams<{ id: string; expenseId: string }>();

  if (!id || !expenseId) {
    return <Navigate to="/groups" replace />;
  }

  return <ExpenseFormWrapper groupId={id} expenseId={expenseId} mode="edit" />;
}
